import { ReactNode } from 'react';
import { Box, css, styled, SxProps, BoxProps, Theme } from '@mui/material';

interface Props extends BoxProps {
  isLegacy?: boolean;
  children: ReactNode | ReactNode[];
  hideScrollbar?: boolean;
  sx?: SxProps<Theme>;
}

const BodyRoot = styled(Box, { shouldForwardProp: prop => prop !== 'isLegacy' })<Props>`
  ${({ theme, isLegacy, hideScrollbar }) => css`
    padding: ${isLegacy ? `15px` : `${theme.spacing(2)}`};
    flex: 1;
    overflow: ${hideScrollbar ? 'hidden' : 'auto'};
    background: ${isLegacy ? '#42434e' : 'transparent'};
  `}
`;

const PageBody = ({ children, sx, isLegacy = false, hideScrollbar = false }: Props) => {
  return (
    <BodyRoot isLegacy={isLegacy} sx={sx}>
      {children}
    </BodyRoot>
  );
};

export default PageBody;
